module.exports = __webpack_public_path__ + "static/media/Industry-Bold.7625d0cb.woff";